
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FdLoading',
  setup() {
    const src = require('@/assets/deepLoadingFd.png')
    return {
      src
    }
  }
})
